import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';

class LayoutWave extends ChiptaElement {

  static get properties() {
    return {
      inverse: {
        type: Boolean,
        reflect: true,
        attribute: "inverse"
      }
    };
  }

  render() {
    return html`
      <div id="outer-container">
        <div id="inner-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1646 61"
            preserveAspectRatio="none"
          >
            <path d="M0 0V40.5331C89.061 42.4113 186.905 43.4721 284.75 42.5237C380.962 41.5912 477.175 38.716 573.387 35.8408L573.396 35.8406C708.097 31.8151 842.799 27.7897 977.5 29.0952C1157.1 30.836 1336.7 42.0541 1516.31 53.2722C1558.19 55.8882 1600.07 58.5042 1641.95 61H1646V6.10352e-05L0 0Z" />
          </svg>
        </div>
      </div>
    `;
  }

  static get styles() {
    return css`

      :host {
        display: block;
      }

      #outer-container {
        position: relative;
      }

      #inner-container {
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: 100%;
        height: 23px;
        top: -9px;
      }
      :host([inverse]) #inner-container {
        top: -16px;
      }

      svg {
        width: 100%;
      }
      :host([inverse]) svg {
        transform: rotatex(180deg);
      }

      path {
        fill: ${unsafeCSS(_themeData.background_color)};
      }

    `;
  }
}

customElements.define('layout-wave', LayoutWave);
